import { render, staticRenderFns } from "./new-order-data.vue?vue&type=template&id=ec8022b6&scoped=true&"
import script from "./new-order-data.vue?vue&type=script&lang=js&"
export * from "./new-order-data.vue?vue&type=script&lang=js&"
import style0 from "./new-order-data.vue?vue&type=style&index=0&id=ec8022b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8022b6",
  null
  
)

export default component.exports